import { Action } from '../actions';
import {
    CLOSE_PREDICTOR_RECOMMENDATION,
    ClosePredictorRecommendationAction,
    FETCH_PREDICTOR,
    FETCH_PREDICTOR_MAP,
    FETCH_PREDICTOR_RECOMMENDATION,
    FetchPredictorAction,
    FetchPredictorMapAction,
    FetchPredictorRecommendationAction,
    SHOW_PREDICTOR_REACH_ERROR,
    SHOW_PREDICTOR_REACH_RECOMMENDATION_ERROR,
    ShowPredictorReachErrorAction,
    ShowPredictorReachRecommendationErrorAction,
    UPDATE_BANNERS_PREDICTOR,
    UPDATE_PREDICTOR_REACH,
    UPDATE_PREDICTOR_REACH_MAP,
    UPDATE_PREDICTOR_REACH_RECOMMENDATION,
    UpdateBannersPredictorAction,
    UpdatePredictorReachAction,
    UpdatePredictorReachMapAction,
    UpdatePredictorReachRecommendationAction
} from '../actions/predictor';
import { MassActionId } from '../typings/groupsEditState';
import { PredictorState, State } from '../typings/state';

const updatePredictorData = (state: PredictorState, action: UpdatePredictorReachAction): PredictorState => {
    const groupData = state.data[action.data.groupId];

    return {
        ...state,
        data: {
            ...state.data,
            [action.data.groupId]: {
                ...groupData,
                isLoading: false,
                detailed: action.data.detailed,
                basic: action.data.basic,
                id: action.data.reqId,
                error: ''
            }
        }
    };
};

const updateBannersPredictor = (state: PredictorState, action: UpdateBannersPredictorAction): PredictorState => {
    const groupData = state.data[action.groupId];

    return {
        ...state,
        data: {
            ...state.data,
            [action.groupId]: {
                ...groupData,
                banners: action.data
            }
        }
    };
};

const fetchPredictorData = (state: PredictorState, action: FetchPredictorAction): PredictorState => {
    const groupData = state.data[action.groupId];

    return {
        ...state,
        data: {
            ...state.data,
            [action.groupId]: {
                ...groupData,
                isLoading: true,
                error: '',
                isExpanderOpened: false
            }
        }
    };
};

const fetchPredictorRecommendationData = (
    state: PredictorState,
    action: FetchPredictorRecommendationAction
): PredictorState => {
    const groupData = state.data[action.groupId];

    return {
        ...state,
        data: {
            ...state.data,
            [action.groupId]: {
                ...groupData,
                isLoadingRecommendation: true,
                recommendationError: '',
                isExpanderOpened: true
            }
        }
    };
};

const updatePredictorRecommendationData = (
    state: PredictorState,
    action: UpdatePredictorReachRecommendationAction
): PredictorState => {
    const groupData = state.data[action.groupId];

    return {
        ...state,
        data: {
            ...state.data,
            [action.groupId]: {
                ...groupData,
                isLoadingRecommendation: false,
                bannerFormats: action.bannersFormats,
                recommendationError: ''
            }
        }
    };
};

const showPredictorError = (state: PredictorState, action: ShowPredictorReachErrorAction): PredictorState => {
    const groupData = state.data[action.groupId];

    return {
        ...state,
        data: {
            ...state.data,
            [action.groupId]: {
                ...groupData,
                isLoading: false,
                error: action.errorMassage
            }
        }
    };
};

const showPredictorRecommendationError = (
    state: PredictorState,
    action: ShowPredictorReachRecommendationErrorAction
): PredictorState => {
    const groupData = state.data[action.groupId];

    return {
        ...state,
        data: {
            ...state.data,
            [action.groupId]: {
                ...groupData,
                isLoadingRecommendation: false,
                recommendationError: action.errorMessage
            }
        }
    };
};

const closePredictorRecommendation = (
    state: PredictorState,
    action: ClosePredictorRecommendationAction
): PredictorState => {
    const groupData = state.data[action.groupId];

    return {
        ...state,
        data: {
            ...state.data,
            [action.groupId]: {
                ...groupData,
                isExpanderOpened: false
            }
        }
    };
};

const fetchPredictorOutdoorData = (state: PredictorState, action: FetchPredictorMapAction): PredictorState => {
    const groupData = state.data[action.groupId];

    return {
        ...state,
        data: {
            ...state.data,
            [action.groupId]: {
                ...groupData,
                isLoading: true,
                error: ''
            }
        }
    };
};

const updatePredictorMapData = (state: PredictorState, action: UpdatePredictorReachMapAction): PredictorState => {
    const groupData = state.data[action.data.groupId];

    return {
        ...state,
        data: {
            ...state.data,
            [action.data.groupId]: {
                ...groupData,
                isLoading: false,
                detailed: action.data.detailed,
                basic: action.data.basic,
                otsDetailed: action.data.otsDetailed,
                otsBasic: action.data.otsBasic,
                id: action.data.reqId,
                error: ''
            }
        }
    };
};

export const initialPredictorState: PredictorState = {
    data: {
        [MassActionId.groupsEdit]: {
            isLoading: false,
            isLoadingRecommendation: false,
            isExpanderOpened: false
        }
    }
};

export function predictor(
    state: PredictorState = initialPredictorState,
    action: Action,
    fullState: State
): PredictorState {
    switch (action.type) {
        case FETCH_PREDICTOR:
            return fetchPredictorData(state, action);
        case FETCH_PREDICTOR_RECOMMENDATION:
            return fetchPredictorRecommendationData(state, action);
        case UPDATE_PREDICTOR_REACH:
            return updatePredictorData(state, action);
        case UPDATE_PREDICTOR_REACH_RECOMMENDATION:
            return updatePredictorRecommendationData(state, action);
        case SHOW_PREDICTOR_REACH_ERROR:
            return showPredictorError(state, action);
        case SHOW_PREDICTOR_REACH_RECOMMENDATION_ERROR:
            return showPredictorRecommendationError(state, action);
        case CLOSE_PREDICTOR_RECOMMENDATION:
            return closePredictorRecommendation(state, action);
        case UPDATE_BANNERS_PREDICTOR:
            return updateBannersPredictor(state, action);
        case UPDATE_PREDICTOR_REACH_MAP:
            return updatePredictorMapData(state, action);
        case FETCH_PREDICTOR_MAP:
            return fetchPredictorOutdoorData(state, action);
        default:
            return state;
    }
}
